import Vue from 'vue'
import { AdminConfig, AdminPageHeader } from 'stylemix-vue-admin'
import Layout from '../components/Layout'
import Axios from 'axios'
import logo from '../assets/images/taxi-logo.png'

AdminConfig.setLogo(logo)
AdminConfig.useAxios()
AdminConfig.useAlerts()
AdminConfig.useAuth({
  storagePrefix: `${process.env.VUE_APP_STORAGE_PREFIX}-admin`,
  withRegistration: false,
})

AdminConfig.setDefaultRoute({
  name: 'dashboard',
})

// For convenience add frequently used components as global
Vue.component('layout', Layout)
Vue.component('page-header', AdminPageHeader)

Axios.interceptors.response.use(
  response => response,
  error => {
    let response = error.response
    if (response && response.status) {
      let message =
        response.data && response.data.message
          ? response.data.message
          : `Server responded with status ${response.status} ${response.statusText}`

      if (response.status >= 400 && response.status < 500) {
        Vue.$toast.warning('Sorry', message)
      }

      if (response.status >= 500) {
        Vue.$toast.error('Oops!', message)
      }
    }

    return Promise.reject(error)
  },
)
